// Замена данных в запросе
export enum ForbiddenZonesUpdateRequest {
  Source = 'ForbiddenZoneID',
  Target = 'ForbiddenZones'
}
